import { render, staticRenderFns } from "./SettingView.vue?vue&type=template&id=3449f6f9&scoped=true&"
import script from "./SettingView.vue?vue&type=script&lang=js&"
export * from "./SettingView.vue?vue&type=script&lang=js&"
import style0 from "./SettingView.vue?vue&type=style&index=0&id=3449f6f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3449f6f9",
  null
  
)

export default component.exports